



























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { BasicUserResourceModel, UserResourceInAdminModel } from '@/modules/user/models/user-resource.model'
import { AdminUserService } from '@/modules/user/services/admin-user.service'
import { UserInfoGetUseCase } from '@/modules/user/use-cases/admin/user-info-get-use.case'
import AdminUserInfoDialog from '@/modules/user/components/admin/AdminUserInfoDialog.vue'

@Component({
  inheritAttrs: false,
  components: { TextEllipsis, BaseButton }
})
export default class AdminUserInfoButton extends Vue {
  @Prop() basicUser: BasicUserResourceModel
  @Prop({ default: '' }) defaultText: string
  @Prop({ default: true }) asText: boolean //show the component as a button when it is false
  @Prop({ default: 'ion person' }) icon: string
  private user: UserResourceInAdminModel = null

  constructor(
    private readonly adminUserInfoService: AdminUserService,
    private readonly userInfoGetUseCase: UserInfoGetUseCase
  ) {
    super()
  }

  sendRequest() {
    const promise = this.userInfoGetUseCase.execute(this.basicUser.id)
    promise.on('success', () => {
      this.user = this.userInfoGetUseCase.data
    }).then(() => {
      this.openUserInfo()
    })
  }

  openUserInfo() {
    this.$q.dialog({
      component: AdminUserInfoDialog,
      user: this.user
    })
  }

  get displayName() {
    return (this.basicUser !== null) ? this.basicUser.displayname : this.defaultText
  }

}
